import { createFileRoute } from '@tanstack/react-router';

import { ReviewCreate } from '@/module/Author/Review/ReviewCreate';

export const Route = createFileRoute('/_auth/author/_author/review/_review/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ReviewCreate />;
}
